import lang from '@/lang';

export function useFieldValidation() {

  const serverValidationErrors = {};
  const getErrorMessage = (params, formField, type, comparisonField) => {
    return lang.formValidation[type](formField, params, comparisonField);
  };

  const validateStatus = ({
    field, serverKey, label, comparisionField = null,
  }) => {
    let validationRules = [];
    validationRules = {
      invalid: field.$invalid,
      dirty: field.$dirty,
      errors: [],
    };

    field.$errors.forEach((error) => {
      const params = error.$params;
      validationRules.errors.push({
        type: params.type,
        status: error.$response,
        message: getErrorMessage(params, label, params.type, comparisionField),
      });
    });

    if (serverValidationErrors[serverKey]) {
      validationRules.errors.push({
        type: 'serverValidation',
        status: false,
        message: serverValidationErrors[serverKey],
      });
    }

    return validationRules;
  };

  const validateBlur = ({ field, serverKey }) => {
    field.$touch();
    serverValidationErrors[serverKey] = null;
  };

  return {
    validateStatus,
    getErrorMessage,
    validateBlur,
    serverValidationErrors,
  };
}
